import React from "react";
import styles from "./Header.module.css";
import logo from "../../assets/logo.png";
import Facebook from "../../assets/icons/facebook.svg";
import Instagram from "../../assets/icons/instagram.svg";
import Linkedin from "../../assets/icons/linkedin.svg";
import Whatsapp from "../../assets/icons/whatsapp.svg";
import useMedia from "../../hooks/useMedia";

import close from "../../assets/header/close.svg";
import menu from "../../assets/header/menu2.svg";

import Link from "next/link";

import { useRouter } from "next/router";
import Image from "next/future/image";

const Header = () => {
  const mobile = useMedia("(max-width: 40rem)");
  const [mobileMenu, setMobileMenu] = React.useState(false);
  const { pathname } = useRouter();

  React.useEffect(() => {
    if (mobileMenu) {
      window.scrollTo(0, 0);
    }
  }, [mobileMenu]);

  React.useEffect(() => {
    if (mobile) {
      const links = document.querySelectorAll("[data-menu] li a");

      function closeMenu({ target }) {
        if (target.href === window.location.href) {
          setMobileMenu(false);
        }
      }
      links.forEach((link) => {
        link.addEventListener("click", closeMenu);
        // link.addEventListener('touchstart', closeMenu);
      });
    }
  });

  React.useEffect(() => {
    setMobileMenu(false);
    window.scrollTo(0, 0);
  }, [pathname]);

  if (mobile) {
    return (
      <header className={styles.header}>
        <div></div>
        <section className=" container-main">
          <Link href="/">
            <a>
              <Image className={styles.logo} src={logo} alt="salinas-logo" />
            </a>
          </Link>
          <button
            aria-label="Menu"
            className={`${styles.mobileButton} ${
              mobileMenu && styles.mobileButtonActive
            }`}
            onClick={() => setMobileMenu(!mobileMenu)}
          >
            <Image src={menu} alt="menu-hamburger" height={30} width={30} />
          </button>
        </section>

        <nav className={styles.navHeader}>
          <ul
            data-menu
            className={`${styles.mobileMenu} ${
              mobileMenu && styles.mobileMenuActive
            } 
`}
          >
            <button onClick={() => setMobileMenu(false)}>
              <Image src={close} alt="close" height={30} width={30} />
            </button>
            <li>
              <Link href="/">Home</Link>
            </li>
            <li>
              <Link href="/empresa">Empresa</Link>
            </li>
            <li>
              <Link href="/sustentabilidade">Sustentabilidade</Link>
            </li>
            <li>
              <Link href="/produtos-e-tecnologia">Produtos e Tecnologia</Link>
            </li>
            <li>
              <Link href="/parceiros">Parceiros</Link>
            </li>
            <li>
              <Link href="/contato">Contato</Link>
            </li>
          </ul>
        </nav>
      </header>
    );
  }

  return (
    <header className={styles.header}>
      <div></div>
      <section className=" container-main">
        <Link href="/">
          <a>
            <Image
              className={styles.logo}
              width={2000}
              height={680}
              src={logo}
              alt="salinas-logo"
            />
          </a>
        </Link>

        <ul className={styles.listIcons}>
          <li>
            <a
              href="https://pt-br.facebook.com/salinasembalagem/"
              target="_blank"
              rel="noreferrer"
            >
              <Image
                className={styles.iconsSocial}
                height={30}
                width={30}
                alt="facebook-logo"
                src={Facebook}
              />
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/salinasembalagem/"
              target="_blank"
              rel="noreferrer"
            >
              <Image
                className={styles.iconsSocial}
                height={30}
                width={30}
                alt="instagram-logo"
                src={Instagram}
              />
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/in/salinas-embalagem-011768174/"
              target="_blank"
              rel="noreferrer"
            >
              <Image
                alt="linkedin-logo"
                className={styles.iconsSocial}
                height={30}
                width={30}
                src={Linkedin}
              />
            </a>
          </li>
          <li>
            <a
              href="https://api.whatsapp.com/send?phone=5514982180404"
              target="_blank"
              rel="noreferrer"
            >
              <Image
                className={styles.iconsSocial}
                height={30}
                alt="whatsapp-logo"
                width={30}
                src={Whatsapp}
              />
            </a>
          </li>
        </ul>
      </section>
      <nav className={styles.navHeader}>
        <ul className={`${styles.navgation}  container-main`}>
          <li>
            <Link href="/">Home</Link>
          </li>
          <li>
            <Link href="/empresa">Empresa</Link>
          </li>
          <li>
            <Link href="/sustentabilidade">Sustentabilidade</Link>
          </li>
          <li>
            <Link href="/produtos-e-tecnologia">Produtos e Tecnologia</Link>
          </li>
          <li>
            <Link href="/parceiros">Parceiros</Link>
          </li>
          <li>
            <Link href="/contato">Contato</Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
